export enum JOYRIDE_TARGET_IDS {
  FILTERS_TAB = 'default-filters-left-nav-item',
  ACCOUNT_MENU = 'account-menu-button'
}
